let compatibilityCheck = false;

// check compatibility
// if selected tag is included in vehicle tags
if (
  existingYearData !== null &&
  existingMakeType !== null &&
  existingModelType !== null &&
  existingEngineType !== null
) {
  const handle = $("section.product").data("product-handle");
  if (handle) {
    jQuery.get(`/products/${handle}.js`, function (res) {
      let data = JSON.parse(res);
      let tags = data.tags;

      const selectedVehicleHandle = getVehicleTag();

      if (tags.includes(selectedVehicleHandle)) {
        $(".compatible").show();
        $(".incompatible").hide();
        compatibilityCheck = true;
      } else {
        $(".incompatible").show();
      }
    });
  }

  const vehicleInfo = (
    existingYearData +
    " " +
    existingMakeType +
    " " +
    existingModelType +
    " " +
    existingEngineType
  ).toUpperCase();

  $(".vehicle-model").text(vehicleInfo);
  $(".check-compatibility").hide();
} else {
  $(".compatible").hide();
  $(".incompatible").hide();
  $(".warning").show();
  $(".check-compatibility").show();
}

function isCompatible() {
  return compatibilityCheck;
}
